<script>
    import { TOKEN_SESSION, USER , TOAST_MESSAGE} from "../../stores";
    import * as Fx from '../../globals/Fx.js'
    import { createEventDispatcher } from "svelte";
    import GLOBALS from "../../globals/GLOBALS";
    import { onMount } from 'svelte'
    import DropList from "../DropList.svelte";
    
    const dispatch = createEventDispatcher();
    
    export let opacity = 0
    export let periodo = null
    
    String.prototype.lines = function() { return this.split(/\r*\n/); }
    String.prototype.lineCount = function() { return this.lines().length; }
    
    
    let value = null
    let inputBaseGravable = {}
    let inputMinimoLiquidar = {}
    let inputMinimoImporte = {}
    let TABLABASEGRAVABLE = []
    let bas_tarifa_aplicada = null

    onMount(() => {
        // _LIQ_QUERY("TABLABASEGRAVABLE", {periodo : periodo, bas_tarifa_aplicada})
    })
    
    $:  if ( periodo && bas_tarifa_aplicada) {
        _LIQ_QUERY("TABLABASEGRAVABLE", {periodo : periodo, bas_tarifa_aplicada})
    }

    const _analizeData = (texto) => {
        cantConsumos = texto.lineCount()
        totalConsumos = 0
        let r
        texto.lines().forEach((item,idx) => {
            if(item.length > 0){
                r = item.split(/\t/)
                totalConsumos += parseFloat(r[1].replace(",","."))
            }
        })
    }

    
    const _guardarBaseGravable = () => {
        let data = []
        Object.keys(inputBaseGravable).forEach((key,i) =>{
            if (inputBaseGravable[key]) {
                data.push({ 
                        bas_periodo : key.split("-")[0], 
                        bas_estrato : key.split("-")[1], 
                        bas_tarifa_aplicada : bas_tarifa_aplicada, 
                        bas_base_gravable : inputBaseGravable[key].value,
                        bas_monto_minimo_liq : inputMinimoLiquidar[key].value ,
                        bas_monto_minimo_importe : inputMinimoImporte[key].value 
                    })
                }
        })
        _LIQ_QUERY("GUARDARBASEGRAVABLE",{data})
    }

    const _LIQ_QUERY = async (QUERY, data) => {
        // const data = {};
        const URL = GLOBALS.URL;
        const bearer = "Bearer " + $TOKEN_SESSION;
        await fetch(`${URL}/API/liquidaciones/QUERY/${QUERY}`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                Authorization: bearer,
                "Content-type": "application/json;charset=UTF-8",
            },
        })
            // Handle success
            .then((response) => response.json()) // convert to json
            .then((json) => {
                if (json.result === "success") {
                    switch(QUERY){
                        case "TABLABASEGRAVABLE":
                            TABLABASEGRAVABLE = json.rows
                        break;
                        case "GUARDARBASEGRAVABLE":
                            if (json.result === "success") {
                                // _btnCloseBaseGravable()
                                // json.message = "Datos almacenados correctamente!!"
                                //_LIQ_QUERY("INICIARLIZARLIQUIDACIONES",{periodo : periodo})
                            }else{
                            }
                            TOAST_MESSAGE.set(json)
                        break;
                        case "INICIARLIZARLIQUIDACIONES":
                        if (json.result === "success") {
                            _close()
                            json.message = "Datos almacenados correctamente!!"
                        }else{
                        }
                        TOAST_MESSAGE.set(json)
                    break;
                    }
                }else{
                    TOAST_MESSAGE.set(json)
                    if (json.status === 403) TOKEN_SESSION.set(null)
                }
                
            }) //print data to console
            .catch((err) => -console.log("Request Failed", err)); // Catch errors
    };
    
    const _saveConsumos = async () => {
        let data = []
        let r
        value.lines().forEach((item,idx) => {
            if(item.length > 0){
                r = item.split(/\t/)
                data.push({liq_id_contrato:r[0],liq_csmo_energia:parseFloat(r[1].replace(",","."))})
            }
        })
        await _LIQ_QUERY("SAVECONSUMOS",{periodo,data})
    }
    
    const _close = () => {
        inputBaseGravable = {}
        dispatch("close")
    }

    
    const _bindSelected = (event) => {
        
        switch(event.detail.lis_tipo){
            case "COMERCIALIZADOR" :
                // formData.sus_id_comercializador = event.detail.choosen.lis_id
                // formData.desc_comercializador = event.detail.choosen.lis_descripcion
            break;
            case "ESTRATO" :
                // formData.sus_id_estrato = event.detail.choosen.lis_id
                // formData.desc_estrato = event.detail.choosen.lis_descripcion
            break;
            case "TARIFA APLICADA" :
                // formData.sus_id_tarifa = event.detail.choosen.lis_id
                // formData.desc_tarifa = event.detail.choosen.lis_descripcion
                bas_tarifa_aplicada = event.detail.choosen.lis_id
            break;
        }
    }
   
    </script>
    
    <div class="basegravable-container" style="opacity: {opacity};">
        <div class="d-flex flex-column align-items-center justify-content-center mt-3">
            <h4> Base Gravable y Montos Mínimos</h4>
            <p>Puedes determinar el valor de la base gravable y montos mínimos que se utilizan en el cáculo de las liquidaciones, por estrato para cada periodo de liquidación y tarifa aplicada.</p>
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center">
            <div class="form-control d-flex flex-row align-items-center justify-content-center px-2 mb-2" style="width: 600px;background-color:#efefef">
                <label style="white-space: nowrap; margin-right: 5px" for="ls-tarifa">Tarifa Aplicada</label>
                <DropList id="ls-tarifa" lis_tipo="TARIFA APLICADA" selected={0} on:_onChange={_bindSelected} />
                <div class="d-flex flex-column align-items-center justify-content-center align-items-center fs-2 mx-2" style="font-size:1.2em; cursor:pointer">
                    <ion-icon name="play-circle-outline"></ion-icon>
                </div>
            </div>
            {#each TABLABASEGRAVABLE as item}
                 <!-- <div>{JSON.stringify(item)}</div> -->
                 <div class="d-flex flex-row justify-content-center">
                    <div class="form-floating mb-1 ms-1 ">
                        <input disabled type="number" value={item.bas_periodo} class="form-control" id="bas_periodo" placeholder="periodo"  pattern="[0-9]+">
                        <label for="bas_periodo">Periodo</label>
                    </div>
                    <!-- <div class="form-floating mb-1 ms-1 ">
                        <input disabled type="number" value={item.lis_id} class="form-control" id="lis_id" placeholder="id"  pattern="[0-9]+">
                        <label for="lis_id">id</label>
                    </div> -->
                    <div class="form-floating mb-1 ms-1 ">
                        <input disabled type="text" value={item.lis_descripcion} class="form-control" id="lis_descripcion" placeholder="Estrato"  pattern="[0-9]+">
                        <label for="lis_descripcion">Estrato</label>
                    </div>
                    <div class="form-floating mb-1 ms-1 ">
                        <input type="number" bind:this={inputBaseGravable[`${periodo}-${item.lis_id}`]} value={item.bas_base_gravable} class="form-control" id="bas_base_gravable" placeholder="Base Gravable"  pattern="[0-9]+">
                        <label for="bas_base_gravable">Base Gravable</label>
                    </div>
                    <div class="form-floating mb-1 ms-1 ">
                        <input type="number" bind:this={inputMinimoLiquidar[`${periodo}-${item.lis_id}`]} value={item.bas_monto_minimo_liq} class="form-control" id="bas_monto_minimo_liq" placeholder="Mínimo Liquidar"  pattern="[0-9]+">
                        <label for="bas_monto_minimo_liq">Mínimo a Liquidar</label>
                    </div>
                    <div class="form-floating mb-1 ms-1 ">
                        <input type="number" bind:this={inputMinimoImporte[`${periodo}-${item.lis_id}`]} value={item.bas_monto_minimo_importe} class="form-control" id="bas_monto_minimo_importe" placeholder="Monto Importe Mínimo"  pattern="[0-9]+">
                        <label for="bas_monto_minimo_importe">Monto Importe Mínimo</label>
                    </div>
                 </div>

            {:else}
                 <!-- empty list -->
            {/each}
        </div>
        {#if bas_tarifa_aplicada}
            <div class="d-flex flex-row justify-content-center mt-3">
                <div class="btn btn-primary ms-2" on:click={() => _guardarBaseGravable()}>Guardar</div>
                <div class="btn btn-danger ms-2"  on:click={() => _close()}>Cerrar</div>
            </div>  
        {:else}
             <!-- else content here -->
        {/if}
  

    </div>

    
    <style>
        .basegravable-container {
            width: 100%;
        }
    

    </style>